// import { Skeleton } from "antd";
// import { PLAYER_URL, PLAYER_URL_NEW } from "../../api";

// interface IProps {
//   height?: number;
//   videoUrl?: string;
//   key?: number;
//   player: "old" | "new";
// }

// export default function StudioPlayer({
//   height = 620,
//   videoUrl,
//   key = 0,
//   player,
// }: IProps) {
//   if (!videoUrl) {
//     return <Skeleton active />;
//   }
//   return (
//     <iframe
//       title="KGS Player"
//       height={height}
//       width={"100%"}
//       key={key}
//       frameBorder={0}
//       style={{
//         borderRadius: 10,
//         padding: 5,
//       }}
//       src={`${
//         player === "new" ? PLAYER_URL_NEW : PLAYER_URL
//       }player?src=${videoUrl}`}
//     ></iframe>
//   );
// }

import { HlsPlayer } from "@playerkit/react";

interface IProps {
  height?: number;
  videoUrl?: string;
  key?: number;
  player: "old" | "new";
}

export default function StudioPlayer({
  videoUrl,
  key = 0,
}: IProps) {

  return (
    <div
      key={key}
      className="w-full overflow-hidden rounded-lg"
    >
      <div className="aspect-video w-full">
        <HlsPlayer
          src={videoUrl}
          theme="default"
          autoPlay
          muted={false}
          seekStep={10}
          disableDevOptions={false}
          debugTouchZones={false}
          playbackRates={undefined}
          themeOverrides={{
            "--pk-accent": "#2E3192",
          }}
          customization={{
            showPlayButton: false,
            showTimeDisplay: true,
            showSettings: true,
            showFullscreen: true,
            showCenterOverlay: true,
            showObjectFitButton: true,
            volumeControl: "vertical",
            centerOverlayGap: 80,
            objectFit: "contain",
          }}
        />
      </div>
    </div>
  );
}